import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { ContentEditable } from '@lexical/react/LexicalContentEditable'
import { useLexicalIsTextContentEmpty } from '@lexical/react/useLexicalIsTextContentEmpty'
import { LexicalEditor } from 'lexical'
import { RefObject } from 'react'

import { RichTextInput, RichTextInputProps } from '../RichTextInput'
import { OPEN_MENTIONS_MENU_COMMAND } from './mentions/MentionsPlugin'

export type LexicalRichTextInputProps = Omit<RichTextInputProps, 'onSendClick' | 'isEmpty'> & {
    onSendMessage?: (editor: LexicalEditor) => void
    inputRef?: RefObject<HTMLDivElement | null>
    placeholder?: string
}

export const LexicalRichTextInput = ({ onSendMessage, isLoading, inputRef, placeholder = 'Skriv en kommentar', ...rest }: LexicalRichTextInputProps) => {
    const [editor] = useLexicalComposerContext()
    const isEmpty = useLexicalIsTextContentEmpty(editor)

    return (
        <RichTextInput
            {...rest}
            onSendClick={onSendMessage ? () => onSendMessage(editor) : undefined}
            isLoading={isLoading}
            isValid={!isEmpty}
            isEmpty={isEmpty}
            onOpenMentionsClick={() => {
                editor.dispatchCommand(OPEN_MENTIONS_MENU_COMMAND, undefined)
            }}
            inputElement={
                <ContentEditable
                    className="relative h-full w-full outline-none"
                    placeholder={isEditable => (isEditable ? <div className="pointer-events-none absolute left-0 top-0 text-subtle">{placeholder}</div> : null)}
                    aria-placeholder={placeholder}
                    ref={inputRef}
                    data-test="lexical-rich-text-input-content-editable"
                />
            }
        />
    )
}
